import { ActionFunctionArgs } from 'react-router-dom';

import { QueryClient } from '@tanstack/react-query';

import { isDefined } from '@hsp/utilities';

import { authenticationService } from 'services';
import { IUser } from 'types/user';
import { s } from 'utilities/strings';

export const registerAction = (_: QueryClient) => {
  return async ({ request }: ActionFunctionArgs) => {
    const formData = await request.formData();
    const userRequest: Record<string, string> = {};

    formData.forEach((value, key) => (userRequest[key] = value as string));

    try {
      let fn: null | ((data: IUser) => Promise<IUser> | undefined) = null;

      if (process.env.REACT_APP_API_AUTH_FAKE === 'jwt') {
        fn = authenticationService.postJwtRegister;
      } else if (process.env.REACT_APP_API_AUTH_FAKE === 'fake') {
        fn = authenticationService.postFakeRegister;
      }

      if (isDefined(fn)) {
        const response = await fn.call(authenticationService, userRequest as unknown as IUser);

        if (!isDefined(response)) {
          throw new Error(s('Api.UnknownError'));
        }

        return response;
      }

      throw new Error(s('Api.UnknownError'));
    } catch (e) {
      return { error: e };
    }
  };
};
